import React from 'react';
import Image from 'next/image';

import { getScaledImageHeight } from '../../../utils/getScaledImageHeight';
import { getImageData } from '../../../utils/contentful';

import {
  LogoContainer,
  PositionerBox,
  StyledGreenlightIcon,
  AffiliateLogo,
  VerticalDivider
} from './styles';

import { StyledGreenlightLogo } from '../../AffiliateHeader/styles';

import glLogoAbbr from '@/images/gl-logo-abbreviated.svg';
import verticalDivider from '@/images/vertical-divider.svg';

interface AffiliateLogoGroupingTypes {
  affiliateLogo: any;
  useGreenlightIcon?: boolean | null;
}

export function AffiliateLogoGrouping({
  affiliateLogo,
  useGreenlightIcon
}: AffiliateLogoGroupingTypes) {
  const { src, alt, width, height } = getImageData(affiliateLogo);

  const AFFILIATE_LOGO_MIN_HEIGHT_PX = 22;
  const AFFILIATE_LOGO_MAX_HEIGHT_PX = useGreenlightIcon ? 40 : 55;

  const logoWidth = width || 1;
  const logoHeight = height || 1;

  const { imageHeight } = getScaledImageHeight(
    logoWidth,
    logoHeight,
    AFFILIATE_LOGO_MIN_HEIGHT_PX,
    AFFILIATE_LOGO_MAX_HEIGHT_PX
  );

  const affiliateLogoHeight = `${parseInt(imageHeight) * 2}rem`;

  return (
    <LogoContainer useGreenlightIcon={useGreenlightIcon}>
      <PositionerBox useGreenlightIcon={useGreenlightIcon}>
        {useGreenlightIcon ? (
          <StyledGreenlightIcon src={glLogoAbbr} alt="Greenlight Icon" />
        ) : (
          <StyledGreenlightLogo isMenuOpen={false} />
        )}
      </PositionerBox>
      <VerticalDivider>
        <Image src={verticalDivider} alt="Vertical divider" />
      </VerticalDivider>
      <PositionerBox useGreenlightIcon={useGreenlightIcon}>
        <AffiliateLogo
          src={src}
          logoHeight={useGreenlightIcon ? imageHeight : affiliateLogoHeight}
          alt={alt ?? 'Affiliate Logo'}
        />
      </PositionerBox>
    </LogoContainer>
  );
}
